type CaptureException = (
    error: unknown,
    hint?: { extra?: Record<string, unknown> },
) => void;

function getCaptureException(): CaptureException | undefined {
    return (window as unknown as { berghsCaptureException?: CaptureException })
        .berghsCaptureException;
}

/**
 * Report an error to Sentry, if it is available.
 *
 * The Sentry SDK ships in its own bundle that is only loaded when a DSN is
 * configured, so `window.berghsCaptureException` may be undefined. This is a
 * no-op in that case.
 */
export function reportError(
    error: unknown,
    extra?: Record<string, unknown>,
): void {
    getCaptureException()?.(error, extra ? { extra } : undefined);
}
